import BigNerdRanch from './BigNerdRanch.png'
import ClusterTruck from './ClusterTruck.png'
import Me from './Me.jpg'
import Memoji from './Memoji.png'
import Proposable from './Proposable.png'
import Udacity from './Udacity.png'


let Images = {
    'BigNerdRanch': BigNerdRanch,
    'ClusterTruck': ClusterTruck,
    'Me': Me,
    'Memoji': Memoji,
    'Proposable': Proposable,
    'Udacity': Udacity
}

export default Images;